// @flow
/* eslint jsx-a11y/no-static-element-interactions:0 */

/*
  **** PLEASE DO NOT USE THIS COMPONENT! ****

  This PinRep is now deprecated and should not be used. It was replaced by the Lego PinRep, which lives
  at app/common/react/components/PinRep. This deprecated PinRep will be deleted in the near future.

  As of November 2019, this is only seen by partners.
*/

// Note: Currently navigation is done using Denzel code, until this is
// converted, please use PinRep
import React, { lazy } from 'react';
import { connect } from 'react-redux';
import 'app/common/react/components/common/Social/styles/socialExperiments.scss';
import contextLogger from 'app/common/lib/ContextLogger';
import cx from 'classnames';
import DebugPinImpressions from 'app/common/react/components/DeprecatedPinRep/DebugPinImpressions';
import DeepLink from 'app/common/react/components/growth/unauth/lib/DeepLink';
import dispatchReportPin from 'app/common/react/components/undiscovery/FlagPin/SimplifiedReportPin/action/dispatchReportPin';
import feedbackHelpers from 'app/packages/pin-utils/feedbackHelpers';
import i18n from 'app/common/lib/i18n';
import PinActionWrapper from 'app/common/react/components/DeprecatedPinRep/PinActionWrapper';
import PinAttribution from 'app/common/react/components/DeprecatedPinRep/attribution/PinAttribution';
import PinCredits from 'app/common/react/components/DeprecatedPinRep/attribution/PinCredits';
import PinDescription from 'app/common/react/components/DeprecatedPinRep/PinDescription';
import PinImage from 'app/common/react/components/PinRep/components/PinVisual/PinImage';
import PinLink from 'app/common/react/components/DeprecatedPinRep/PinLink';
import PinPrice from 'app/common/react/components/DeprecatedPinRep/PinPrice';
import PinRepChips from 'app/common/react/components/DeprecatedPinRep/PinRepChips';
import PinRepSaved from 'app/common/react/components/PinRep/components/Saved';
import PinShapeProps from 'app/common/react/components/DeprecatedPinRep/PinShapeProps';
import PinStatsOnGrid from 'app/common/react/components/PinAnalytics/PinStatsOnGrid';
import PinTitle from 'app/common/react/components/DeprecatedPinRep/PinTitle';
import PinTypeIdentifier from 'app/common/react/components/DeprecatedPinRep/PinTypeIdentifier/PinTypeIdentifier';
import PinVideoWithVisibility from 'app/common/react/components/PinRep/components/PinVisual/PinVideoWithVisibility';
import PropTypes from 'prop-types';
import RecipeSummary from 'app/common/react/components/DeprecatedPinRep/RecipeSummary';
import SafeSuspense from 'app/packages/safe-suspense';
import SendShareFlyoutButtonFullWidth from 'app/common/react/components/PinRep/components/PinRepSendShareFlyoutButtonFullWidth';
import smartTruncate from 'app/common/lib/util/smartTruncate';
import Testable from 'app/common/react/ui/Testable';
import TextTransformer from 'app/common/react/components/common/TextTransformer/TextTransformer';
import type { CarouselPinData } from 'app/packages/pinterest-flow-types/pin';
import type { Dispatch } from 'redux';
import type { Experience } from 'app/common/lib/react/experiences/experienceUtils';
import type { PinType as PinToBoardType } from 'app/common/react/components/save/pin-to-board/PinToBoard/PinToBoard';
import type { PinTypes } from 'app/common/react/components/DeprecatedPinRep/PinTypeIdentifier/PinType';
import type { Router } from 'app/common/lib/ReactRouter/types';
import type { SaveTarget } from 'app/common/redux/reducers/pin';
import type { SetVideoParams } from 'app/common/redux/actions/app';
import type { State as ReduxState } from 'app/common/redux/types';
import type { Videos } from 'app/packages/pinterest-flow-types/video';
import type { VideosAutoplaying } from 'app/common/redux/reducers/ui/app';
import urlUtil from 'app/common/lib/urlUtil';
import withPlacement from 'app/common/lib/react/experiences/withPlacement';
import zIndices from 'app/common/react/components/DeprecatedPinRep/styles/zIndices';
import { buildPinDeeplinks } from 'app/common/lib/deeplinkRoutes';
import { compose } from 'redux';
import { Experiment } from 'app/common/react/components/experiments';
import { getCommerceAuxData } from 'app/common/lib/CommerceUtil';
import { getEligiblePinTypes } from 'app/common/react/components/DeprecatedPinRep/PinTypeIdentifier/PinType';
import { getPinGifOrImageSrc } from 'app/common/react/components/growth/unauth/pin/pinUtils';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { setCurrentVideo } from 'app/common/redux/actions/app';
import { SingleTreatmentExp } from 'app/common/lib/experiment';
import { track } from 'app/common/lib/react/analytics';
import { type SaveButtonOptions } from 'app/common/react/components/PinRep/components/PinRepPrimaryContent';
import { withRouter } from 'react-router';
import type {
  FeedbackType,
  FeedbackTextType,
} from 'app/common/react/components/PinRep/feedback-types';
import withViewer, { type Viewer } from 'app/common/lib/react/withViewer';
import {
  buildPinRepLink,
  isPromotedPin,
  isVideoPlaying,
  isVideoPin,
} from 'app/common/lib/util/PinUtils';
import {
  withRequestContext,
  RequestContextPropType,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';
import { Box, Text } from 'gestalt';
import { isNewUser, isResurrectedUser } from 'app/common/lib/ActivationUtil';

const PinFeedbackButton = lazy(() =>
  import(/* webpackChunkName: "PinFeedbackButtonCommon" */ 'app/common/react/components/DeprecatedPinRep/PinFeedback/PinFeedbackButton'),
);
const PinFeedbackConfirmation = lazy(() =>
  import(/* webpackChunkName: "PinFeedbackConfirmationCommon" */ 'app/common/react/components/DeprecatedPinRep/PinFeedback/PinFeedbackConfirmation'),
);
const PinTypeIdentifierPinType = lazy(() =>
  import(/* webpackChunkName: "PinTypeIdentifierCommon" */ 'app/common/react/components/DeprecatedPinRep/PinTypeIdentifier/PinType'),
);

const PIN_WIDTH = 228;

type ReduxStateProps = {|
  boardCount?: number,
  carouselIndex?: number,
  feedbackText?: FeedbackTextType,
  hideSaveButton?: boolean,
  isHomefeedContextualMenuTooltipExperience?: boolean,
  isNewOrResurrectedNonPartner: boolean,
  isShareable: boolean,
  isSocialSeasonalBoard: boolean,
  pinsBoardEditableByViewer?: boolean,
  savedInfo: ?SaveTarget,
  showFeedback: ?boolean,
  showFeedbackOverlay?: boolean,
  undoAction?: () => void,
  undoText?: string,
  videosAutoplaying: VideosAutoplaying,
|};

type ReduxDispatchProps = {|
  setCurrentVideo: (setVideoParams: SetVideoParams) => void,
|};

export type OwnProps = {|
  componentType?: number,
  contextLogData?: Object,
  createdAt?: string,
  debugImpressionLogged?: boolean,
  debugImpressionStarted?: boolean,
  denseViewSelected?: boolean,
  feedback?: {|
    data?: Object,
    type: FeedbackType,
  |},
  hideAttribution?: boolean,
  hideFeedbackButton?: boolean,
  hideHover?: boolean,
  highResOnly?: boolean,
  lowResOnly?: boolean,
  onError?: Function,
  onLoad?: Function,
  pin: Object,
  saveOptions?: SaveButtonOptions,
  searchOptions?: {
    query: string,
    scope: string,
  },
  selection?: 'NO_SELECTION' | 'SELECTED' | 'UNSELECTED',
  showCondensedInfo?: boolean,
  showCredits?: boolean,
  showImageOnly?: boolean,
  showPinReactionsReply?: boolean,
  showPinStats?: boolean,
  showProductInfo?: boolean,
  showSavedInfo?: boolean,
  slotIndex: number,
  truncatePinHeight?: boolean,
  viewParameter?: $Values<PCONST.thrift.ViewParameterType>,
  viewType?: $Values<PCONST.thrift.ViewType>,
|};

type HOCProps = {|
  dispatch: Dispatch<any>,
  experience: ?Experience,
  requestContext: RequestContextType,
  router: Router,
  viewer: Viewer,
|};

type Props = {|
  ...ReduxStateProps,
  ...ReduxDispatchProps,
  ...HOCProps,
  ...OwnProps,
|};

type State = {|
  flyoutShown: boolean,
  flyoutSource?: 'save' | 'send',
  isHovering: boolean,
  isNewlySaved: boolean,
  savedInfo: ?SaveTarget,
|};

export const SelectionState = {
  NO_SELECTION: 'NO_SELECTION',
  SELECTED: 'SELECTED',
  UNSELECTED: 'UNSELECTED',
};

export type PinRepType = PinToBoardType & {
  board_activity?: {
    id: string,
  },
  carousel_data?: CarouselPinData,
  image_crop?: ?{
    max_y: number,
    min_y: number,
  },
  images?: {
    '236x': {
      height?: number,
      url?: string,
      width?: number,
    },
    '474x'?: {
      height?: number,
      url?: string,
      width?: number,
    },
    '736x'?: {
      height?: number,
      url?: string,
      width?: number,
    },
    orig?: {
      height?: number,
      url?: string,
      width?: number,
    },
  },
  story_pin_data_id?: string,
  videos?: {
    id: string,
    video_list: Videos,
  },
};

const getPinStatsData = (pin) => {
  const {
    aggregated_pin_data: { creator_analytics: canonicalPinStats },
    creator_analytics: rootPinStats,
    story_pin_data_id: storyPinDataId,
  } = pin;

  const isStoryPin = !!storyPinDataId;

  // story pins should default to using root pin stats
  if (rootPinStats && (isStoryPin || !canonicalPinStats)) {
    return rootPinStats;
  }
  return canonicalPinStats;
};

export const PinRepPropTypes = {
  boardCount: PropTypes.number,
  carouselIndex: PropTypes.number,
  componentType: PropTypes.number,
  contextLogData: PropTypes.shape({}),
  createdAt: PropTypes.string,
  debugImpressionStarted: PropTypes.bool,
  debugImpressionLogged: PropTypes.bool,
  dispatch: PropTypes.func,
  feedbackText: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node)]),
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node)]),
  }),
  hideFeedbackButton: PropTypes.bool,
  hideHover: PropTypes.bool,
  showImageOnly: PropTypes.bool,
  isShareable: PropTypes.bool,
  showCondensedInfo: PropTypes.bool,
  feedback: PropTypes.shape({
    type: PropTypes.oneOf([
      'promoted',
      'followed',
      'topic',
      'pfyBoard',
      'pfy',
      'search',
      'newsHub',
      'default',
    ]).isRequired,
    data: PropTypes.shape({}),
  }),
  lowResOnly: PropTypes.bool,
  highResOnly: PropTypes.bool,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  pin: PinShapeProps.isRequired,
  pinsBoardEditableByViewer: PropTypes.bool,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  saveOptions: PropTypes.shape({
    type: PropTypes.oneOf(['classic', 'inline', 'controlled', 'persistentOneClickSave']).isRequired,
  }),
  savedInfo: PropTypes.shape({
    boardId: PropTypes.string,
    localPinId: PropTypes.string,
    sectionId: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  searchOptions: PropTypes.shape({
    query: PropTypes.string.isRequired,
    scope: PropTypes.string.isRequired,
  }),
  selection: PropTypes.oneOf([
    SelectionState.NO_SELECTION,
    SelectionState.SELECTED,
    SelectionState.UNSELECTED,
  ]),
  requestContext: RequestContextPropType,
  showCredits: PropTypes.bool,
  showFeedback: PropTypes.bool,
  showPinReactionsReply: PropTypes.bool,
  showProductInfo: PropTypes.bool,
  slotIndex: PropTypes.number.isRequired,
  truncatePinHeight: PropTypes.bool,
  viewer: PropTypes.shape({
    id: PropTypes.string,
    isAuth: PropTypes.bool,
    isPartner: PropTypes.bool,
    username: PropTypes.string,
  }),
  viewParameter: PropTypes.number,
  viewType: PropTypes.number,
};

export class DeprecatedPinRep extends React.Component<Props, State> {
  static propTypes = PinRepPropTypes;

  static contextTypes = {
    unauthId: PropTypes.string.isRequired,
    userAgent: PropTypes.shape({
      platform: PropTypes.string.isRequired,
      platformVersion: PropTypes.arrayOf(PropTypes.number),
      raw: PropTypes.string.isRequired,
    }),
  };

  static defaultProps = {
    pinsBoardEditableByViewer: false,
    showCondensedInfo: false,
    truncatePinHeight: true,
    showSavedInfo: true,
  };

  state = {
    isHovering: false,
    flyoutShown: false,
    flyoutSource: 'send',
    isNewlySaved: false,
    savedInfo: this.props.savedInfo,
  };

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (nextProps.savedInfo && prevState.savedInfo !== nextProps.savedInfo) {
      return { isNewlySaved: true, savedInfo: nextProps.savedInfo };
    }

    return null;
  }

  onPinRepClick = (evt: SyntheticMouseEvent<HTMLDivElement>) => {
    const {
      pin: { id: pinId, is_promoted: isPromoted },
      requestContext,
      router: reactRouter,
      viewer,
      setCurrentVideo,
      videosAutoplaying,
    } = this.props;

    const url = buildPinRepLink(pinId, this.isEligibleForAnalyticsCloseup());

    const isCurrentlyPlaying = isVideoPlaying(pinId, videosAutoplaying);

    if (
      isCurrentlyPlaying &&
      (this.currentVideoCurrentTime === 0 || !!this.currentVideoCurrentTime)
    ) {
      setCurrentVideo({
        pinId,
        isPromoted,
        currentTime: this.currentVideoCurrentTime,
      });
    }

    // NOTE: using `evt.currentTarget` here would break scroll restoration.
    const eventTarget: ?HTMLDivElement = (evt.target: any);
    if (!eventTarget || !eventTarget.nodeName || !eventTarget.parentElement) {
      return;
    }

    const deepLink = new DeepLink(this.context.userAgent.raw, this.context.userAgent.platform);
    if (deepLink.shouldDeepLink(document.referrer, this.context.userAgent, viewer.isAuth)) {
      evt.preventDefault();
      deepLink.navigateToDeepLink(this.context.unauthId, buildPinDeeplinks(pinId));
      return;
    }

    const targetParent = eventTarget.parentElement;
    const targetNodeName = eventTarget.nodeName;
    /* $FlowFixMe nodeName is missing in EventTarget.
      A common way to fix this is by replacing `target` by ` currentTarget`
      however this breaks scroll restoration. (Going from homefeed -> closeup -> homefeed) */
    const targetNodeNameParent = targetParent.nodeName;
    const targetNodeNameParentParent =
      /* $FlowFixMe nodeName is missing in EventTarget.
      A common way to fix this is by replacing `target` by ` currentTarget`
      however this breaks scroll restoration. (Going from homefeed -> closeup -> homefeed) */
      targetParent.parentElement && targetParent.parentElement.nodeName;

    // When you click on a part of the pinrep that doesn't contain a link (e.g. just below the image)
    // we still want to direct you to the correct closeup page
    if (
      targetNodeName !== 'A' &&
      targetNodeNameParent !== 'A' &&
      targetNodeName !== 'BUTTON' &&
      targetNodeNameParent !== 'BUTTON' &&
      targetNodeNameParentParent !== 'A' &&
      targetNodeNameParentParent !== 'BUTTON'
    ) {
      // Activate into the Pin Stats from business profile on click
      // of a part of the PinRep that doesn't contain a link.
      new SingleTreatmentExp(requestContext, 'smb_pin_stats_from_business_profile').enabled();

      if (evt.metaKey || evt.ctrlKey) {
        evt.preventDefault();
        window.open(url);
      } else {
        reactRouter.push(url);
      }
    }
  };

  get canDelete() {
    const { access } = this.props.pin;
    return (access || []).includes('delete');
  }

  get isOwnPin() {
    const { access } = this.props.pin;
    return (access || []).includes('write');
  }

  getComponentType = () => this.props.componentType || PCONST.thrift.ComponentType.FLOWED_PIN;

  getTruncatedString(string: string) {
    const {
      pin: { is_promoted },
    } = this.props;
    const truncationMaxLength = is_promoted ? 60 : 50;
    return (string && smartTruncate(string.trim(), truncationMaxLength)) || '';
  }

  getPinTitle() {
    const {
      pin: { carousel_data, title, buyable_product, rich_summary },
    } = this.props;
    const useRichTitle = rich_summary && rich_summary.type_name !== 'mobile application';

    // Don't return the title when it's your own pin. For carousel pins, title should be shown
    if (this.isOwnPin && !carousel_data) {
      return '';
    }

    if (carousel_data) {
      const { carousel_slots = [], index } = carousel_data;
      if (carousel_slots[index] && carousel_slots[index].title) {
        return carousel_slots[index].title.trim();
      }
    }

    // We always prefer displaying titles (native pin title) than rich titles.
    return this.getTruncatedString(
      title ||
        (useRichTitle && rich_summary.display_name) ||
        (buyable_product && buyable_product.title),
    );
  }

  getSourceURL = () => {
    const { pin } = this.props;
    const { link, tracked_link } = pin;

    return tracked_link || link;
  };

  getPinTypes = (): Array<PinTypes> => {
    const { pin } = this.props;
    const {
      attribution,
      buyable_product,
      carousel_data,
      embed,
      is_collage_pin,
      is_eligible_for_web_closeup,
      rich_summary,
      videos,
    } = pin;
    const pinTypes = [];

    if (carousel_data) {
      pinTypes.push('carousel');
    }

    if (is_eligible_for_web_closeup) {
      pinTypes.push('oneTap');
    }

    if (isVideoPin(videos)) {
      pinTypes.push('video');
    }

    const embedded = embed || (attribution && attribution.embed) || null;
    if (embedded && embedded.type === 'gif') {
      pinTypes.push('gif');
    }

    if (embedded && embedded.src && !embedded.type) {
      pinTypes.push('embeddedVideo');
    }

    if (!!buyable_product || (!!rich_summary && rich_summary.type_name === 'product')) {
      pinTypes.push('product');
    }

    if (!!rich_summary && rich_summary.type_name === 'recipe') {
      pinTypes.push('recipe');
    }

    if (!!is_collage_pin) {
      pinTypes.push('collage');
    }

    return pinTypes;
  };

  getFeedbackType() {
    const { feedback, viewParameter, pin } = this.props;
    return this.feedbackHelpers.getFeedbackType({
      board: pin.board,
      feedback,
      viewParameter,
      pin,
      pinner: pin.pinner,
    });
  }

  feedbackHelpers = feedbackHelpers({
    i18n,
    interpolateNamedTemplate,
  });

  isEligibleForAnalyticsCloseup() {
    const { requestContext, viewParameter, viewer } = this.props;

    const isHomefeed = viewParameter === PCONST.thrift.ViewParameterType.FEED_HOME;
    const isSearch = viewParameter === PCONST.thrift.ViewParameterType.SEARCH_PINS;

    let isEligibleForAnalyticsCloseup = false;

    // Only show analytics if user is a business account viewing their own Pins,
    // not from Homefeed or search surfaces
    if (this.isOwnPin && viewer.isPartner && !isHomefeed && !isSearch) {
      isEligibleForAnalyticsCloseup = new SingleTreatmentExp(
        requestContext,
        'smb_pin_stats_from_business_profile',
      ).enabledWithNoActivation();
    }

    return isEligibleForAnalyticsCloseup;
  }

  handleSave = () => {
    this.setState({
      isHovering: true, // for showing saved confirmation
    });
  };

  handleOneTapLogging = () => {
    const { contextLogData, pin } = this.props;
    const { id: pinId } = pin;

    const eventLogger = contextLogger.getInstance();
    const previousView = eventLogger.getViewFromContext();

    this.handleClickthroughLogging(true);

    track(PCONST.thrift.EventType.VIEW, {
      ...contextLogData,
      closeup_navigation_type: 'web_closeup',
      objectId: pinId,
      component: PCONST.thrift.ComponentType.FLOWED_PIN,
      view: PCONST.thrift.ViewType.PIN,
    });

    // Ensure view is reset to the previous view before
    // closeup view event was emitted
    eventLogger.addViewToContext(previousView);
  };

  _getPrefetchCompletionPercent = (link: string) => {
    // if prefetch hasn't started, return 0 to indicate 0% was downloaded
    if (!window || !window.prefetchCompletion || !window.prefetchCompletion[link]) {
      return '0';
    }

    const { downloadedAssets, totalAssets } = window.prefetchCompletion[link];
    // if there are no assets, return -1 for logging purposes
    if (!totalAssets) {
      return '-1';
    }
    return ((downloadedAssets / totalAssets) * 100).toFixed(3).toString();
  };

  handleClickthroughLogging = (isOneTap?: boolean) => {
    const {
      contextLogData,
      pin: { id: pinId, link },
      slotIndex,
      viewType,
      viewParameter,
    } = this.props;

    track(PCONST.thrift.EventType.PIN_CLICKTHROUGH, {
      ...contextLogData,
      view: viewType,
      viewParameter,
      component: this.getComponentType(),
      objectId: pinId,
      grid_index: slotIndex,
      pin_id: pinId,
      prefetch_percentage_complete: isOneTap ? this._getPrefetchCompletionPercent(link) : null,
    });
  };

  handleReactionReplyClick = (activityUrl: string) => () => this.props.router.push(activityUrl);

  handleToggleFlyout = (
    showFlyout: boolean,
    keepHover: boolean = false,
    flyoutSource?: 'save' | 'send',
  ) => {
    const newHoveringState = !!(showFlyout || keepHover);
    this.setState({ flyoutShown: showFlyout, isHovering: newHoveringState, flyoutSource });
  };

  handleMouseOver = () => {
    if (!this.state.isHovering) {
      this.setState(() => ({ isHovering: true }));
    }
  };

  handleMouseLeave = () => {
    if (this.state.isHovering) {
      this.setState(() => ({ isHovering: false }));
    }
  };

  currentVideoCurrentTime: ?number;

  // $FlowFixMe Flow v0.104.0 upgrade supression.
  handleCurrentVideoCurrentTimeChanged = (args: $Subtype<{ time: number }>) => {
    const { pin, videosAutoplaying } = this.props;
    const { id: pinId } = pin;

    const isCurrentlyPlaying = isVideoPlaying(pinId, videosAutoplaying);

    if (isCurrentlyPlaying) {
      this.currentVideoCurrentTime = args.time;
    }
  };

  render() {
    const {
      boardCount,
      carouselIndex,
      contextLogData,
      createdAt,
      debugImpressionLogged,
      debugImpressionStarted,
      denseViewSelected,
      experience,
      feedback,
      feedbackText,
      isHomefeedContextualMenuTooltipExperience,
      isNewOrResurrectedNonPartner,
      isSocialSeasonalBoard,
      hideAttribution,
      hideFeedbackButton,
      showCondensedInfo,
      showFeedbackOverlay,
      isShareable,
      hideHover,
      hideSaveButton,
      lowResOnly,
      highResOnly,
      onError,
      onLoad,
      pin,
      pinsBoardEditableByViewer,
      saveOptions: customSaveOptions,
      savedInfo,
      searchOptions,
      selection = SelectionState.NO_SELECTION,
      showImageOnly,
      slotIndex,
      truncatePinHeight,
      viewer,
      viewParameter,
      viewType,
      showCredits,
      showFeedback,
      showProductInfo,
      showPinReactionsReply,
      showPinStats,
      showSavedInfo,
      undoAction,
      undoText,
      requestContext,
    } = this.props;

    // Derive imageOnly and imageOnlyAttribution from showImageOnly and the
    // viewer's state.
    const imageOnly =
      typeof showImageOnly === 'boolean' ? showImageOnly : isNewOrResurrectedNonPartner;
    const imageOnlyAttribution = isNewOrResurrectedNonPartner;

    const {
      ad_match_reason,
      aggregated_pin_data,
      board,
      board_activity: boardActivity,
      buyable_product,
      carousel_data,
      creator_analytics,
      debug_info_html,
      description = '',
      domain,
      dominant_color,
      grid_title: gridTitle,
      id: pinId,
      image_signature,
      images,
      is_quick_promotable: isQuickPromote,
      is_eligible_for_web_closeup,
      pinner = {},
      promoted_is_removable: promotedIsRemovable,
      promoter,
      recommendation_reason,
      rich_summary,
      source_interest,
      category: pinCategory,
    } = pin;

    const { flyoutShown, flyoutSource, isHovering, isNewlySaved } = this.state;
    // overrides the clickthrough link for a pin once it becomes a Promoted Pin
    const sourceUrl = this.getSourceURL();
    const firstPinCreate = ((experience || {}).display_data || {}).lite;
    const showOwnPinActionButtons = (this.isOwnPin || this.canDelete) && !firstPinCreate;
    const showGenericPinActionButtons = !firstPinCreate && isShareable;
    const contextLogDataExpanded = {
      ...contextLogData,
      ...getCommerceAuxData(pin, contextLogData),
    };
    const { done: doneCount } = (aggregated_pin_data || {}).aggregated_stats || {};
    const { pin_tags_chips: pinTagsChips } = aggregated_pin_data || {};
    const imageHeight = images && images['236x'].height;
    const imageWidth = images && images['236x'].width;

    const pinTypes = this.getPinTypes();
    const isPromoted = isPromotedPin(pin);
    const { isCarousel, isOneTap, isRecipe, isStoryPin, isVideo } = getEligiblePinTypes(pinTypes);

    const pinGridTitle = isStoryPin ? '' : this.getTruncatedString(gridTitle);
    const pinTitle = this.getPinTitle();
    const pinDescription = this.getTruncatedString(description);

    const isInImageOnly = imageOnly;

    // NOTE: move_pin_grid_title_and_desc_to_backend in control group will send null
    // also in case if the field_set_key didn't contain grid_title, we're being strict here.
    const hasPinGridTitle = !isInImageOnly && typeof gridTitle === 'string' && !carousel_data;

    const hasDescription = !isInImageOnly && !pinTitle && !hasPinGridTitle;
    const hasTitle = !!(!isInImageOnly && pinTitle && !hasPinGridTitle && !isSocialSeasonalBoard);

    const pinClasses = cx('PinRep', 'Module', 'Pin', 'hasAttribution', 'summary', 'fullWidth', {
      flyoutShown,
    });

    const bestPinImgSrc = getPinGifOrImageSrc(pin);

    const showPinType = pinTypes.length > 0;

    // pinTypes is the array that contains all labels for what type of Pin this is, which
    // can contain icons that are both above the title or below the title.
    // For Carousel, we want to make sure the pip dots are shown above the title.
    // For video, we want to make sure we no longer show anything above the title. For recipes, it
    // needs to have aggregate rating information for anything to be shown above the title.
    const noPinTypeUnderMedia =
      (!isOneTap && !isCarousel && isVideo) ||
      (isRecipe &&
        !isCarousel &&
        (!pin.rich_summary ||
          !pin.rich_summary.aggregate_rating ||
          !pin.rich_summary.aggregate_rating.review_count));
    const showTitle = !isSocialSeasonalBoard && hasTitle && pinTitle.length > 0;
    const showDescription = !isSocialSeasonalBoard && hasDescription && pinDescription.length > 0;
    const showFullWidthSend = !showTitle && !showDescription && isSocialSeasonalBoard;
    const animateGif = isSocialSeasonalBoard && pinTypes.includes('gif');
    const showDebug = viewer.isAuth && viewer.isEmployee && debug_info_html;
    const hasPinStatsData =
      Object.keys(creator_analytics || {}).length !== 0 ||
      (Object.keys(aggregated_pin_data || {}).length !== 0 &&
        Object.keys(aggregated_pin_data.creator_analytics || {}).length !== 0);

    // Better save: automagically pick a board for the user to save to
    const saveOptions =
      customSaveOptions ||
      (!showOwnPinActionButtons && boardCount !== undefined && boardCount > 1
        ? { type: 'inline' }
        : { type: 'classic' });

    const showSendButton =
      viewer.isAuth && showGenericPinActionButtons && isShareable && !showFullWidthSend;

    const isPersistentOneClickSave = saveOptions.type === 'persistentOneClickSave';
    // saveOptions is used to determine the button type but for persistent one click save
    // savedInfo is a property on saveOptions as it does not need to be read from redux
    const persistentOneClickSaveTitle =
      (saveOptions && saveOptions.savedInfo && saveOptions.savedInfo.title) || '';

    const feedbackType = this.getFeedbackType();

    let domainDisplay = domain;
    if (carousel_data) {
      const carouselIdx = carouselIndex || carousel_data.index || 0;
      const { carousel_slots = [] } = carousel_data;
      const link = (carousel_slots[carouselIdx] && carousel_slots[carouselIdx].link) || '';
      domainDisplay = link && urlUtil.parse(link).hostname;
      domainDisplay = (domainDisplay && domainDisplay.replace('www.', '')) || domain;
    }

    const hasPinCredits =
      pin.is_native ||
      pin.promoter ||
      (!isInImageOnly && (showCredits || feedbackType === 'followed'));
    // Reactions from Board Activity
    const showReactions = pin.board && pin.board.should_show_board_activity;
    const showPinCredits = showReactions && hasPinCredits && !hideAttribution;

    const isHomefeedContextualMenuTooltip =
      slotIndex === 1 && !!isHomefeedContextualMenuTooltipExperience;

    const show90DaysPinStatsOnGrid = new SingleTreatmentExp(
      requestContext,
      'px_pinstats_90_day_default_on_grid',
    ).enabled();

    // Note: please do not copy this paradigm of adding onClick handlers
    // inside a div. We do this here to make all parts of the pin that aren't
    // links or buttons navigate to the pin closeup, and we can't make this div
    // a button/anchor tag becasue we can't have nested buttons or anchor tags
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/mouse-events-have-key-events */
    return (
      <Box position="relative">
        <div
          className={pinClasses}
          onMouseOver={this.handleMouseOver}
          onMouseLeave={this.handleMouseLeave}
          data-test-id="pin"
          data-test-pin-id={pin.id}
        >
          {savedInfo &&
            showSavedInfo && (
              <Testable id="savedInfo">
                <Box
                  width="172px"
                  marginTop={isPersistentOneClickSave ? 3 : 2}
                  paddingY={3}
                  paddingX={3}
                  position="absolute"
                  left
                  top
                  dangerouslySetInlineStyle={{ __style: { zIndex: zIndices.saved } }}
                >
                  <PinRepSaved
                    isNewlySaved={isNewlySaved}
                    name={isPersistentOneClickSave ? persistentOneClickSaveTitle : savedInfo.title}
                    url={
                      isPersistentOneClickSave
                        ? saveOptions && saveOptions.savedInfo && saveOptions.savedInfo.url
                        : savedInfo.url
                    }
                  />
                </Box>
              </Testable>
            )}
          <DebugPinImpressions
            debugImpressionLogged={debugImpressionLogged}
            debugImpressionStarted={debugImpressionStarted}
            slotIndex={this.props.slotIndex}
          >
            <div
              className={cx('pinWrapper', showFeedback && 'disableHover')}
              data-test-id="pinWrapper"
              onClick={this.onPinRepClick}
            >
              {showPinCredits &&
                showReactions && (
                  <Box marginBottom={2}>
                    <PinCredits
                      hideTitle={!!showReactions}
                      pin={pin}
                      viewParameter={viewParameter}
                      viewType={viewType}
                    />
                  </Box>
                )}
              {/* eslint-enable jsx-a11y/click-events-have-key-events */}
              {/* eslint-enable jsx-a11y/mouse-events-have-key-events */}
              {is_eligible_for_web_closeup && (
                <PinLink
                  pinDeeplinkUrls={buildPinDeeplinks(pinId)}
                  handleOneTapLogging={this.handleOneTapLogging}
                  pinId={pinId}
                  sourceUrl={sourceUrl}
                />
              )}
              {/* For new users 7 or less days old, trigger NUX one tap experiment. */}
              <Experiment
                name="web_nux_one_tap_save"
                isEligible={viewer.isAuth && isNewUser({ user: viewer, days: 7 })}
              >
                {({ anyEnabled: inNewUserOneTapExperiment }) => (
                  <PinActionWrapper
                    boardActivity={boardActivity}
                    buyableProduct={buyable_product}
                    componentType={this.getComponentType()}
                    contextLogData={contextLogDataExpanded}
                    denseViewSelected={denseViewSelected}
                    description={description}
                    domain={domainDisplay}
                    dominantColor={dominant_color}
                    doneCount={doneCount}
                    hideSaveButton={hideSaveButton}
                    imageHeight={imageHeight}
                    imageSignature={image_signature}
                    images={images}
                    imageWidth={imageWidth}
                    showReactions={showReactions}
                    isEligibleForWebCloseup={is_eligible_for_web_closeup}
                    isEligibleForAnalyticsCloseup={this.isEligibleForAnalyticsCloseup()}
                    inNewUserOneTapExperiment={inNewUserOneTapExperiment}
                    onSave={this.handleSave}
                    onToggleFlyout={this.handleToggleFlyout}
                    pin={pin}
                    pinsBoardEditableByViewer={pinsBoardEditableByViewer}
                    pinTitle={pinTitle}
                    requestContext={requestContext}
                    saveOptions={saveOptions}
                    searchOptions={searchOptions}
                    selection={selection}
                    showButtons={!!((isHovering && !hideHover) || flyoutShown)}
                    showCondensedInfo={showCondensedInfo}
                    // TODO: Consider representing using a list instead of bools
                    showEditPinButton={showOwnPinActionButtons}
                    showPromoteButton={isQuickPromote}
                    showRepinButton={!isQuickPromote && !promotedIsRemovable}
                    showSendButton={showSendButton}
                    slotIndex={slotIndex}
                    sourceUrl={sourceUrl}
                    truncatePinHeight={truncatePinHeight}
                    viewer={viewer}
                    viewParameter={viewParameter}
                    viewType={viewType}
                    isFlyoutOpen={flyoutShown && flyoutSource !== 'save'}
                  >
                    <Experiment name="ads_desktop_video_ads" isEligible={isVideo} activate={false}>
                      {({ anyEnabled: inAdsDesktopVideoExperiment }) =>
                        isVideo && (inAdsDesktopVideoExperiment || !isPromoted) ? (
                          <PinVideoWithVisibility
                            inAdsDesktopVideoExperiment={inAdsDesktopVideoExperiment}
                            isExperimentalPinRep={false}
                            lowResOnly={lowResOnly}
                            highResOnly={highResOnly}
                            onLoad={onLoad}
                            onError={onError}
                            pin={pin}
                            saved={!!savedInfo}
                            onTimeChange={this.handleCurrentVideoCurrentTimeChanged}
                            viewType={viewType}
                            viewParameter={viewParameter}
                            currentTimeFromPinRep={this.currentVideoCurrentTime}
                          />
                        ) : (
                          <PinImage
                            lowResOnly={lowResOnly}
                            highResOnly={highResOnly}
                            onLoad={onLoad}
                            onError={onError}
                            pin={pin}
                            saved={!!savedInfo}
                            animateGif={animateGif}
                          />
                        )
                      }
                    </Experiment>
                  </PinActionWrapper>
                )}
              </Experiment>
              {/* Pin tag chips
                we may have more or less than 3 chips returned by the API if the pin is promoted,
                since we need to prefetch some data for closeup */}
              {!!pinTagsChips &&
                !showCondensedInfo &&
                pinTagsChips.length >= 3 && <PinRepChips chips={pinTagsChips.slice(0, 3)} />}
              {showFullWidthSend && (
                <Box marginTop={2} marginBottom={3} width="100%">
                  <Box width={PIN_WIDTH} margin="auto">
                    <SendShareFlyoutButtonFullWidth
                      onFlyoutDismiss={() =>
                        this.handleToggleFlyout(!flyoutShown && flyoutSource !== 'save')
                      }
                      onToggleFlyout={() =>
                        this.handleToggleFlyout(!flyoutShown && flyoutSource !== 'save')
                      }
                      pinId={pin.id}
                      sendType="pin"
                      shownWithinMasonry
                      isFlyoutOpen={flyoutShown && flyoutSource !== 'save'}
                      viewType={viewType}
                    />
                  </Box>
                </Box>
              )}
              {/* Pin Meta Wrapper */}
              {(!isInImageOnly || feedbackType) &&
                !showCondensedInfo &&
                !showFullWidthSend &&
                (showPinType ||
                  showPinStats ||
                  showTitle ||
                  showDescription ||
                  showProductInfo ||
                  createdAt ||
                  hasPinGridTitle ||
                  showDebug ||
                  feedbackType) && (
                  <Box display="flex" direction="row" marginTop={1}>
                    {/* We need the 100% width here for an IE11 flexbox bug */}
                    <Box paddingX={2} flex="grow" width="100%">
                      {/* pin stats */}
                      {showPinStats &&
                        hasPinStatsData && (
                          <PinStatsOnGrid
                            stats={getPinStatsData(pin)}
                            isVideo={isVideo}
                            isStoryPin={!!pin.story_pin_data_id}
                            show90Days={show90DaysPinStatsOnGrid}
                          />
                        )}
                      {/* timestamp */}
                      {createdAt &&
                        !isPromoted && (
                          <Box paddingY={1}>
                            <Text color="darkGray" size="xs">
                              {i18n.getHumanizedTimesince(createdAt)}
                            </Text>
                          </Box>
                        )}
                      {/* type identifier */}
                      {/* Min height keeps space here while PinType async loads */}
                      {showPinType &&
                        !noPinTypeUnderMedia && (
                          <Box data-test-id="pin-type" minHeight={isCarousel && isOneTap ? 40 : 24}>
                            <SafeSuspense>
                              <PinTypeIdentifierPinType
                                componentType={PCONST.thrift.ComponentType.FLOWED_PIN}
                                viewParameter={viewParameter}
                                viewType={viewType}
                                pinId={pinId}
                                pin={pin}
                                types={pinTypes}
                              />
                            </SafeSuspense>
                          </Box>
                        )}
                      <Box display="flex" justifyContent="between">
                        <Box column={12}>
                          {!!pin.story_pin_data_id && (
                            <Box paddingY={1}>
                              <PinTypeIdentifier icon="story-pin" pinId={pinId} />
                            </Box>
                          )}
                          <PinPrice
                            buyableProduct={buyable_product}
                            richSummary={rich_summary}
                            showProductInfo={showProductInfo}
                          />
                          {/* pinGridTitle */}
                          {hasPinGridTitle &&
                            pinGridTitle.length > 0 && (
                              <Box paddingY={1}>
                                <Text size="sm" weight="bold">
                                  <TextTransformer
                                    text={pinGridTitle}
                                    options={{
                                      hashtags: {
                                        appendText: pinGridTitle,
                                        source: 'hashtag_pinrep',
                                      },
                                    }}
                                  />
                                </Text>
                              </Box>
                            )}
                          {/* title */}
                          {hasTitle &&
                            pinTitle.length > 0 && <PinTitle title={pinTitle} pinId={pinId} />}
                          {/* description */}
                          {hasDescription &&
                            pinDescription.length > 0 && (
                              <PinDescription description={pinDescription} pinId={pinId} />
                            )}
                          {isRecipe && <RecipeSummary richSummary={rich_summary} />}
                          {/* attribution */}
                          <PinAttribution
                            feedbackType={feedbackType}
                            hideAttribution={hideAttribution}
                            imageOnly={isInImageOnly}
                            imageOnlyAttribution={imageOnlyAttribution}
                            isHovering={isHovering}
                            isVideo={isVideo}
                            onClickThrough={this.handleClickthroughLogging}
                            onReactionReplyClick={this.handleReactionReplyClick}
                            pin={pin}
                            showCredits={showCredits}
                            showPinReactionsReply={showPinReactionsReply}
                            sourceUrl={sourceUrl}
                            viewParameter={viewParameter}
                            viewType={viewType}
                          />
                        </Box>
                      </Box>

                      {/* feed debugging */}
                      {showDebug && (
                        <Box paddingY={1}>
                          <pre>{debug_info_html}</pre>
                        </Box>
                      )}
                    </Box>
                    <Box display="flex" direction="column" alignItems="center">
                      {/* pin feedback menu */}
                      {/*
                                TODO: Remove zIndex here when one tap links are refactored
                                The feeedback menu needs to be above the one tap link
                                which is positioned absolutely
                              */}
                      {!hideFeedbackButton &&
                        feedbackType && (
                          <Box
                            data-test-id="feedback-button"
                            display="flex"
                            justifyContent="end"
                            position="relative"
                            dangerouslySetInlineStyle={{
                              __style: { zIndex: zIndices.max },
                            }}
                            // Save space here for the button so height doesn't change after async load
                            width={24}
                            height={24}
                          >
                            <SafeSuspense>
                              <PinFeedbackButton
                                ad_match_reason={ad_match_reason}
                                bestPinImgSrc={bestPinImgSrc}
                                board={board}
                                feedbackData={(feedback && feedback.data) || {}}
                                feedbackType={feedbackType}
                                hideDownload={isVideo}
                                isHomefeedContextualMenuTooltip={isHomefeedContextualMenuTooltip}
                                pinDescription={pinDescription}
                                pinTitle={pinTitle}
                                pinId={pinId}
                                pinCategory={pinCategory}
                                pinImage={images && images['236x'].url}
                                pinner={pinner}
                                promoter={promoter}
                                recommendationReason={recommendation_reason}
                                reportPin={dispatchReportPin({
                                  pin,
                                  viewParameter,
                                  viewType,
                                })}
                                sourceInterest={source_interest}
                                viewParameter={viewParameter}
                                viewType={viewType}
                              />
                            </SafeSuspense>
                          </Box>
                        )}
                    </Box>
                  </Box>
                )}
            </div>
          </DebugPinImpressions>
        </div>
        <Experiment name="web_homefeed_control_panel_nag" activate={false}>
          {({ anyEnabled: isHomefeedControlPanelNagExp }) => (
            <Experiment name="web_homefeed_control_panel_pin_feedback">
              {({ anyEnabled: isHomefeedControlPanelHeaderExp }) =>
                !!showFeedback && (
                  <SafeSuspense>
                    <PinFeedbackConfirmation
                      feedbackText={feedbackText}
                      feedbackType={feedbackType}
                      pinId={pinId}
                      pinImage={images && images['236x'].url}
                      undoAction={undoAction}
                      undoText={undoText}
                      isHomefeedControlPanelExp={
                        isHomefeedControlPanelNagExp || isHomefeedControlPanelHeaderExp
                      }
                      showFeedbackOverlay={showFeedbackOverlay}
                    />
                  </SafeSuspense>
                )
              }
            </Experiment>
          )}
        </Experiment>
      </Box>
    );
  }
}

const mapStateToProps = (
  { boards, experiences, pins, ui, viewer }: ReduxState,
  { pin: { id: pinId, board } },
) => {
  const pin = pins[pinId];
  const boardCount = viewer.isAuth ? viewer.boardCount : undefined;
  const boardId = board && board.id;
  const localBoard = boards.content[boardId];
  const pinsBoardEditableByViewer = localBoard && (localBoard.access || []).includes('write');
  const { isSocialSeasonalBoard = false } = boards;
  const isNewOrResurrectedNonPartner =
    viewer.isAuth &&
    (isNewUser({ user: viewer }) || isResurrectedUser({ user: viewer })) &&
    !viewer.isPartner;

  let carouselIndexInRedux;
  if (pin) {
    const { carousel_data } = pin;
    carouselIndexInRedux = carousel_data && carousel_data.index;
  }

  const isHomefeedContextualMenuTooltipExperience =
    experiences &&
    experiences.eligibleExperiences &&
    experiences.eligibleExperiences[PCONST.thrift.Placement.HOMEFEED_HIDE_PIN] &&
    experiences.eligibleExperiences[PCONST.thrift.Placement.HOMEFEED_HIDE_PIN].experience_id ===
      PCONST.thrift.Experience.WEB_HOMEFEED_CONTEXTUAL_MENU_TOOLTIP;

  const videosAutoplaying = ui.app
    ? ui.app.videosAutoplaying
    : {
        organicVideosAutoplaying: {},
        promotedVideosAutoplaying: {},
      };

  return {
    isSocialSeasonalBoard,
    boardCount,
    carouselIndex: carouselIndexInRedux,
    isHomefeedContextualMenuTooltipExperience,
    feedbackText: pin && pin.feedbackText,
    hideSaveButton: pin && pin.pinner && pin.pinner.blocked_by_me,
    isNewOrResurrectedNonPartner,
    isShareable: localBoard ? localBoard.privacy !== 'secret' : true,
    pinsBoardEditableByViewer,
    savedInfo: pin && pin.savedInfo,
    showFeedback: pin && pin.showFeedback,
    showFeedbackOverlay: pin && pin.showFeedbackOverlay,
    undoAction: pin && pin.undoAction,
    undoText: pin && pin.undoText,
    videosAutoplaying,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>, ownProps: OwnProps) => ({
  setCurrentVideo: (setVideoParams: SetVideoParams) => dispatch(setCurrentVideo(setVideoParams)),
});

export default compose(
  withRouter,
  withViewer,
  withPlacement(PCONST.thrift.Placement.WEB_PIN_CLOSEUP),
  withRequestContext,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(DeprecatedPinRep);
